/**
 * @generated SignedSource<<cd0f7e59fb122c705086c155b7b40b89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEstimatedValue_item$data = {
  readonly isFurniture: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"estimatedValueFurnitureTestHelpers_item" | "pricingGuidanceHelpers_item" | "useShowPricingGuidance_item">;
  readonly " $fragmentType": "PdpSharedEstimatedValue_item";
};
export type PdpSharedEstimatedValue_item$key = {
  readonly " $data"?: PdpSharedEstimatedValue_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimatedValue_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEstimatedValue_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFurniture",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "estimatedValueFurnitureTestHelpers_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b35463917888d3cc6b483562a8e800d1";

export default node;
